import { SHOW_ERROR, HIDE_ERROR } from "../../constants/action-types";

export const defaultInitialState = {
  isErrorMsgShown: false,
};

export const reducer = (state = defaultInitialState, { type }) => {
  switch (type) {
    case SHOW_ERROR: {
      return {
        ...state,
        isErrorMsgShown: true,
      };
    }
    case HIDE_ERROR: {
      return {
        ...state,
        isErrorMsgShown: false,
      };
    }
    default:
      return state;
  }
};
